/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:0ed4d630-ba83-4fef-a79b-e0437bc001c8",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_4z6xxSwqB",
    "aws_user_pools_web_client_id": "29u8h4ebjhdpmeoucoqcnn45ao",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "awsamplifytest9b5a2ab671de434e85aa3a0081f9988f150205-main",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
